import {executeRequest} from "./request";
import {DOMAIN_URL, USER_SERVICE} from "./configURL";

const APPLICATION_NAME 	= "master_key_system";
const VERSION 			= "1.0.0";
const OS 				= "NULL";

export function authenticate(login, password, project_id) {
	const params = {
		"application_name" : 	APPLICATION_NAME,
		"version" :				VERSION,
		"os" : 					OS,
		login,
		password
	};

	if(project_id) {
		params["project_id"] = project_id;
	}

	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + USER_SERVICE.AUTHENTICATE,
			params,
			reject,
			resolve
		);
	});
}

export function ping() {
	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + USER_SERVICE.PING,
			null,
			reject,
			resolve
		);
	});
}

export function logout() {
	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + USER_SERVICE.LOGOUT,
			null,
			reject,
			resolve
		);
	});
}

export function subscribe(fields) {
	const params = {
		"civility" 		: fields.civility,
		"firstname" 	: fields.firstname,
		"lastname" 		: fields.lastname,
		"function" 		: fields.fonction,
		"password" 		: fields.password,
		"email" 		: fields.email,
		"legal_form" 	: fields.legalForm,
		"company_name" 	: fields.companyName,
		"tax_number" 	: fields.taxNumber,
		"address"		: [fields.address1, fields.address2],
		"postal_code"	: fields.postalCode,
		"city"			: fields.city,
		"country" 		: fields.country

	};

	return new Promise((reject, resolve) => {
		executeRequest(
			DOMAIN_URL + USER_SERVICE.SUBSCRIBE,
			params,
			reject,
			resolve
		);
	});
}



// WEBPACK FOOTER //
// ./src/js/webAPI/userService.js